import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import ColumnIcon from '../common/Icons/Column-Views.svg';

const ColumnButton = (props) => (
    <div>
        <button
            className={ props.styles.columnButton }
            onClick={ props.toggleDropdown }
            type="button"
        >
            Columns
        </button>
        <button
            className={ props.styles.columnButton }
            type="button"
            onClick={ props.toggleDropdown }
        >
            <img src={ ColumnIcon } alt="" className={ props.styles.svg } />
        </button>
    </div>
);

ColumnButton.propTypes = {
    styles: PropTypes.objectOf(PropTypes.string).isRequired,
    toggleDropdown: PropTypes.func
};

ColumnButton.defaultProps = {
    toggleDropdown: noop
};

export default ColumnButton;
